import { render, staticRenderFns } from "./InventoryComponent.vue?vue&type=template&id=592c7d06&scoped=true"
import script from "./InventoryComponent.vue?vue&type=script&lang=js"
export * from "./InventoryComponent.vue?vue&type=script&lang=js"
import style0 from "./InventoryComponent.vue?vue&type=style&index=0&id=592c7d06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592c7d06",
  null
  
)

export default component.exports